export default "__VITE_ASSET__Bp4o2xgI__"